@if (showTrialRibbon) {
  <div class="app-trial-ribbon" role="status" aria-live="polite">
    <span class="app-trial-ribbon__shine" aria-hidden="true"></span>
    <span class="app-trial-ribbon__dot" aria-hidden="true"></span>
    <span class="app-trial-ribbon__label">{{ 'trial.ribbon' | translate }}</span>
    <span class="app-trial-ribbon__dot app-trial-ribbon__dot--end" aria-hidden="true"></span>
  </div>
}

<router-outlet />
<app-toast-container />
